import React, { useState } from "react";
import { IoAdd } from "react-icons/io5";
import { MdClose } from "react-icons/md";
import NewProfileModal from "./NewProfileModal/NewProfileModal"; // adjust path if needed

export default function NewProfile({
  ProfileImage,
  setProfileImage,
  setProfileSection,
}) {
  const [imagePreview, setImagePreview] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageError, setImageError] = useState("");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setProfileImage(file);
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB
      if (fileSizeInMB > 10) {
        setImageError("Image size should be less than 10MB");
      } else {
        // you can also upload or preview here
        const imageUrl = URL.createObjectURL(file);
        setImagePreview(imageUrl);
        setImageError("");
      }
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
    setProfileImage(null);
  };

  const handleSelectAvatarClick = () => {
    setIsModalOpen(true);
    setProfileImage(null);
  };

  const handleNextClick = () => {
    if (!ProfileImage) {
      setImageError("Please select any image or avatar");
      return;
    } else if (imageError) {
      return;
    }
    setProfileSection(2);
  };

  const handleSaveAvatar = (avatar) => {
    setImagePreview(avatar.avtarImage);
    setProfileImage(avatar._id);
    setImageError("");
  };

  return (
    <section
      className="bg-login p-6 md:p-4 pb-16 sm:pb-0 min-h-screen flex items-center justify-center
overflow-x-hidden"
    >
      {!isModalOpen && (
        <div className="w-full max-w-lg p-8 text-center">
          <h2 className="text-2xl font-bold mb-5 capitalize">
            Welcome! Let’s Set Up Your Profile
          </h2>

          <div className="profile-bg">
            <div className="my-4 w-[130px] h-[130px] mx-auto rounded-4xl border border-dashed border-[#000] bg-white overflow-hidden relative">
              <label
                htmlFor="imageUpload"
                className="cursor-pointer w-full h-full flex items-center justify-center"
              >
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    alt="Profile Preview"
                    className="w-full h-full object-cover rounded-4xl"
                  />
                ) : (
                  <IoAdd className="text-[#7104F8] text-4xl" />
                )}
              </label>

              {imagePreview && (
                <button
                  type="button"
                  onClick={handleRemoveImage}
                  className="absolute top-1 right-1 bg-[var(--primary-color)] rounded-full p-1 shadow"
                >
                  <MdClose className="text-white text-xl" />
                </button>
              )}

              <input
                type="file"
                id="imageUpload"
                accept=".jpg,.png"
                onChange={handleImageChange}
                className="hidden"
                value=""
              />
            </div>
          </div>

          <div className="text-center pt-2">
            <p className="text-md text-black font-normal my-3">
              Upload a clear photo of yourself. Click the upload button to
              continue.
            </p>

            <div className="divider">Or</div>

            <p
              onClick={() => handleSelectAvatarClick()}
              className="text-lg font-normal my-6 mt-2 underline text-[#7104F8] cursor-pointer"
            >
              Select Avatar
            </p>
          </div>
          {imageError && (
            <p className="text-red-500 text-sm mb-7">{imageError}</p>
          )}
          <button
            onClick={() => handleNextClick()}
            className="btn btn-default bg-[var(--primary-color)] text-white w-96 h-12 font-normal rounded-full border-0"
          >
            Next
          </button>
        </div>
      )}
      {/* avatar Modal */}
      <NewProfileModal
        isOpen={isModalOpen}
        onSave={(avatar) => handleSaveAvatar(avatar)}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
}
